var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"media-content"},[_c('h3',[_vm._v(" "+_vm._s(_vm.$options.methods.formatEmptyString(_vm.props.language.name))+" ")]),(_vm.props.extended)?_c('small',[_vm._v(" "+_vm._s(_vm.$options.methods.formatEmptyString(_vm.props.language.alias))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }